<template>
  <div v-if="showBlackOverlay" class="black-overlay"></div>
  <router-view />
  <div v-if="showStartOverlay" class="start-overlay">
    <h1 class="overlay-title">Saving Vitalia</h1>
    <img src="@/assets/world/maximum.gif" alt="Game Overlay" class="overlay-image" />
     <button class="start-btn" @click="startGameIntro">
        Play!
      </button>

    <h2 class="overlay-subtitle">The Quest of the Eternal Olive Tree</h2>

  </div>
  <CinematicOverlay 
    :message="overlayMessage[language]" 
    :visible="isOverlayVisible" 
    @start-game="onStartGame" 
    @video-ended="onVideoEnded" 
  />
</template>

<script>
import CinematicOverlay from '@/components/CinematicOverlay.vue';
import { sounds } from '@/utils/sounds.js';

export default {
  components: {
    CinematicOverlay,
  },
  data() {
    return {
      isOverlayVisible: false,
      overlayMessage: 'Welcome to the game!',  // Example message for overlay
      name: 'App',
      language: "en",
      showStartOverlay: true,
      showBlackOverlay: true,
    };
  },
  methods: {
    // Triggered when the start game event occurs
    onStartGame() {
      this.language = localStorage.getItem("language") || "en"; // Default to English
      localStorage.setItem("language", 'en');
      
      this.isOverlayVisible = false;
      this.$router.push({
        name: 'UserAuth',  // Navigates to the main scene when game starts
      });
    },

    // Triggered when the video ends
    onVideoEnded() {
      this.isOverlayVisible = false;
      this.$router.push({
        name: 'UserAuth',  // Navigates to the main scene after the video ends
      });
    },

    startGameIntro() {
      // Stop all sounds except video sound
      if (typeof sounds.stopAll === 'function') {
        sounds.stopAll();
      } else {
        // Fallback: manually stop known sounds
        Object.values(sounds).forEach(snd => {
          if (snd && typeof snd.stop === 'function') {
            snd.stop();
          }
        });
      }
      sounds.click.play();
      this.showStartOverlay = false;
      this.isOverlayVisible = true;
      setTimeout(() => {
        this.showBlackOverlay = false;
      }, 1000);
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
.start-overlay {
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 3000;
}
.overlay-image {
width: 100%;
height: 100%;
object-fit: cover; /* Ensures proper scaling */
position: absolute; /* Ensures the background fills the container */
top: 0;
left: 0;
z-index: -1; /* Places the image behind the button */
filter: blur(5px);
}

.start-button {
  width: 20%;
  padding: 20px 12px;
  background-color: #3498db;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 6px;
  font-size: 24px;
}


.overlay-title {
  position: relative;
  z-index: 1;
  color: white;
  font-size: 3rem;
  margin-bottom: 20px;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.7);
}

.overlay-subtitle {
  position: relative;
  z-index: 1;
  color: white;
  font-size: 1.8rem;
  margin-bottom: 30px;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.7);
}

/* Glassy iOS-style Start button */
.start-btn {
  padding: 1.5rem 3rem;
  font-size: 2rem;
  font-weight: bold;
  color: white;                     /* White text for strong contrast */
  background: #0080ffd9;              /* A solid bright blue background */
  border: 3px solid #ffffff;        /* White border for visibility */
  border-radius: 2rem;
  backdrop-filter: none;            /* Remove blur so text stays crisp */
  box-shadow: 0 6px 25px rgba(0,0,0,0.5);  /* Stronger shadow for depth */
  cursor: pointer;
  transition: all 0.3s ease;
}

.start-btn:hover {
  background: #63b3ff;              /* Lighter blue on hover */
  transform: scale(1.08);
  box-shadow: 0 8px 30px rgba(0,0,0,0.6);
}

.black-overlay {
  position: fixed;
  inset: 0;
  background: black;
  z-index: 2000;
}
</style>
